import { useEffect, useRef } from 'react'
import { fetchStream } from 'common/Prose/nodeViews/AISuggestion/utils'

interface Props {
  jobId: string
  setStreamContent: React.Dispatch<React.SetStateAction<string>>
  signal?: AbortSignal
}

export const StreamContentData = ({ jobId, setStreamContent, signal }: Props) => {
  const internalAbortController = useRef<AbortController>(new AbortController())

  useEffect(() => {
    const controller = internalAbortController.current

    fetchStream({
      jobId,
      onParsedLine: (line: string) => {
        setStreamContent((content) => content + line)
      },
      signal: signal || controller.signal,
    })

    return () => {
      if (!signal) {
        controller.abort()
      }
    }
  }, [jobId, setStreamContent, signal])

  return null
}
